// @flow
import _ from 'lodash';
import type { TDraftLeaguesReducer } from "../../types";

export const getTransactionsHistoryById = (state: TDraftLeaguesReducer) => _.groupBy(
	_.get(state, 'leagues.transaction_history.result', []), 'external_id'
);

export default getTransactionsHistoryById;